<template>
  <div class="view">
    <DeleteContentModal
        v-if="showModal"
        :show="showModal"
        :title="deleteTitle"
        :desc="deleteDescription"
        :interaction="deleteActionType"
        :startdate="deleteInitDate"
        :enddate="deleteEndDate"
        :cat="deleteCategoryId"
        :offer_id="deleteId"
        :image="deleteImages"
        @closeModal="showModal=false"
        />
    <DeviceNotAllowed />
    <ActiveContentModal
        v-if="showActiveModal"
        :show="showActiveModal"
        :data="activeOffers"
        :item="activeOffer"
        @closeActiveModal="showActiveModal=false"
        />
    <PerformanceModal
        v-if="showCreatedModal"
        :show="showCreatedModal"
        :item="createdOffer"
        :catOne="catOne"
        :catTwo="catTwo"
        :catThree="catThree"
        :category_1="category_1"
        :category_2="category_2"
        :category_3="category_3"
        :category_4="category_4"
        :daysCount="daysCount"
        :actualRevenue="actualRevenue"
        @closeCreatedModal="showCreatedModal=false"
        />
    <div class="manager">
      <div class="header">
        <div class="controls">
          <router-link :to="{ name: 'content'}" class="button back sm">
            <i class="icon ico-chevron-left"></i>
            <p>Volver</p>
          </router-link>
          <div class="buttons">
            <button @click="saveNewOrder" v-if="reordered" class="button primary sm umami--click--guardar-nuevo-orden"><i class="icon ico-upload"></i>
              <p>Guardar Nuevo Orden</p></button>
            <router-link :to="{ name: 'new_content'}" class="button primary sm umami--click--nuevo-contenido">
              <i class="icon ico-plus"></i>
              <p>Nuevo Contenido</p>
            </router-link>
          </div>
        </div>
      </div>
      <ContentList class="content-list"
          :data="pageData"
          @deleteContent="deleteContent"
          @checkContent="checkContent"
          @performanceContent="performanceContent"
          @orderContent="orderContent"
          />
      <!-- <paginate
            :page-count="pages"
            :prev-text="prevBtn"
            :next-text="nextBtn"
            :hide-prev-next="true"
            :container-class="'pagination'"
            :click-handler="changePage"
            /> -->
    </div>
  </div>
</template>

<script>
import DeviceNotAllowed from "@/components/DeviceNotAllowed"
import ContentList from "@/components/cards/ContentList"
import DeleteContentModal from "@/components/modals/DeleteContentModal"
import ActiveContentModal from "@/components/modals/ActiveContentModal"
import PerformanceModal from "@/components/modals/PerformanceModal"

// import Paginate from 'vuejs-paginate'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'

export default {
  name: 'ContentManager',
  components: {
    DeviceNotAllowed,
    ContentList,
    // Paginate,
    DeleteContentModal,
    ActiveContentModal,
    PerformanceModal
  },
  data(){
    return{
      showModal: false,
      showActiveModal: false,
      showCreatedModal: false,
      deleteTitle: "",
      deleteDescription: "",
      deleteActionType: "",
      deleteInitDate: "",
      deleteEndDate: "",
      deleteCategoryId: "",
      deleteId: "",
      deleteImages: "",
      activeOffer: "",
      activeOffers: [],
      createdOffer: "",
      catOne: false,
      catTwo: false,
      catThree: false,
      category_1: process.env.VUE_APP_CATEGORY_1,
      category_2: process.env.VUE_APP_CATEGORY_2,
      category_3: process.env.VUE_APP_CATEGORY_3,
      category_4: process.env.VUE_APP_CATEGORY_4,
      daysCount: 0,
      actualRevenue: "",
      page: 1,
      today: moment().format('YYYY-MM-DD'),
      initRange: moment().subtract(30,'d').format('YYYY-MM-DD'),
      reordered: false,
      localData: [],
    }
  },
  created: function(){
        this.$store.dispatch("auth/setActive", "content");
        this.offerRequest("999999")
            .then(r => {
                console.log(r)
            }, err => {
                console.log(err)
            })
        
        // if (this.$route.name == "content_publish" && this.$route.params.id) {
        //   console.log("NEW CONTENT")
        //   console.log(this.$route.params.id)
        //   this.offerRequest("999999")
        //   .then(r => {
        //       console.log()
        //       let created_id = this.$route.params.id
        //       let offers = this.offers
        //       _.each(offers,(item)=>{
        //           if(item.id==created_id){
                    

        //             if(item.category[0].id==1){
        //                 this.catOne = true
        //                 this.catTwo = false
        //                 this.catThree = false
        //             }else if(item.category[0].id==2){
        //                 this.catOne = false
        //                 this.catTwo = true
        //                 this.catThree = false
        //             }else if(item.category[0].id==3){
        //                 this.catOne = false
        //                 this.catTwo = false
        //                 this.catThree = true
        //             }

        //             this.daysCount = this.daysBetween(item.init_date, item.end_date)

        //             this.createdOffer = item
        //             this.showCreatedModal = true
        //             this.$emit('showCreatedModal')
        //           }
        //       })
        //   }, err => {
        //       console.log(err)
        //   })
        
        // }
    },
    methods: {
      ...mapActions({
                  'offerRequest': 'offers/offerRequest',
                  'setCategory': 'offers/selectCategory',
                  'setFilter': 'stores/setFilter',
                  'updateOrderOffers': 'offers/updateOrderOffers'
              }),
      hideModal: function(){
        this.showModal = false
      },
      daysBetween: function(dateString1, dateString2){
            var date1 = new Date(dateString1); 
            if (dateString2) {
                var date2 = new Date(dateString2); 

                // To calculate the time difference of two dates 
                var Difference_In_Time = date2.getTime() - date1.getTime(); 
                
                // To calculate the no. of days between two dates 
                var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
            
                if (Difference_In_Days > 0) {
                    return Difference_In_Days
                } else if (Difference_In_Days < 0) {
                    return 0
                }
                return 1

            }
            return 0
      },
      deleteContent(id){
        _.each(this.offers,(item)=>{
            if(item.id==id){
              this.deleteTitle = item.title
              this.deleteDescription =  item.description
              this.deleteActionType = item.action_type
              this.deleteInitDate = item.init_date
              this.deleteEndDate = item.end_date
              this.deleteCategoryId = item.category[0].id
              this.deleteId = item.id
              this.deleteImages = item.images
            }
        })
        
        this.showModal = true
        this.$emit('showModal')
      },
      checkContent(id){
        this.offerRequest("999999")
        .then(() => {
                let offers = this.offers
                this.activeOffers = []

                this.activeOffer = offers.filter((item) => {
                  return item.id == id
                })[0]

                this.activeOffers = offers.filter(item => {
                  return item.id != id && item.is_active == true && item.category[0].id == this.activeOffer.category[0].id
                })

                this.showActiveModal = true
                // this.$emit('showActiveModal')
            }, err => {
                console.log(err)
            })
      },
      getDetailOfferRevenue: function(offer_id){
          // var offer_id = this.offers[this.offerSlide].id
          let headers = {
              'Authorization': 'ZGFuaWVsQGZyZWRlc0BlbHVuOm51YmU1NDMyMTBuMHVzM3N3MW5kMHJ6'
          }
          axios.get(process.env.VUE_APP_ANALYTICS_HOST+"/api/offers/?init_date="+this.initRange+"&end_date="+this.today+"&store_id=999999&offer_id="+offer_id, {
          headers: headers
          })
          .then((res) => {
              this.actualRevenue = 0
              this.offerClicksCount = 0
              _.each(res.data, (value) => {
                  this.actualRevenue = this.actualRevenue + value["revenue"]
                  this.offerClicksCount = this.offerClicksCount + value["clicks"]
              })
              var offer_revenue = this.actualRevenue.toString().split(".")[0]
              this.actualRevenue = String(offer_revenue).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
          })
          .catch((err) => {
            console.log("ERROR REVENUE")
            console.log(err)
          })
      },
      performanceContent(id){
        this.offerRequest("999999")
        .then(() => {
            let created_id = id
            let offers = this.offers
            _.each(offers,(item)=>{
                if(item.id==created_id){
                  if(item.category[0].id==1){
                      this.catOne = true
                      this.catTwo = false
                      this.catThree = false
                  }else if(item.category[0].id==2){
                      this.catOne = false
                      this.catTwo = true
                      this.catThree = false
                  }else if(item.category[0].id==3){
                      this.catOne = false
                      this.catTwo = false
                      this.catThree = true
                  }

                  this.daysCount = this.daysBetween(item.init_date, item.end_date)
                  this.getDetailOfferRevenue(item.id)
                  this.createdOffer = item
                  this.showCreatedModal = true
                  this.$emit('showCreatedModal')
                }
            })
        }, err => {
            console.log(err)
        })
      },
      hideActiveModal: function(){
        this.showActiveModal = false
      },
      changePage: function(val){
            this.page = val
      },
      orderContent: function(data){
        const currentPageData = this.pageData;
        const areOrdersEqual = JSON.stringify(data) === JSON.stringify(currentPageData);
        if (!areOrdersEqual) {
          this.localData = data;
          this.reordered = true;
        } else {
          this.localData = [];
          this.reordered = false;
        }
      },
      saveNewOrder: function() {
        const newSortedOffers = this.localData;
        const allOffers = this.offers;
        const sortedOffers = []

        newSortedOffers.forEach((offer, index) => {
          sortedOffers.push({
            id: offer.id,
            order: index + 1,
            catId: offer.category[0].id
          })
        })

        allOffers.forEach((offer) => {
          if (!sortedOffers.some(item => item.id === offer.id)) {
            sortedOffers.push({
              id: offer.id,
              order: sortedOffers.length + 1,
              catId: offer.category[0].id
            })            
          }
        })
        
        const updateOffers = []
        const catId = []
        for (const offer of sortedOffers) {
          if (!catId.some(item => item.id === offer.catId)) {
            catId.push({id:offer.catId, order:1}) 
            updateOffers.push({id: offer.id, order: 1})
          } else {
            const index = catId.findIndex(item => item.id === offer.catId)
            catId[index].order += 1
            const order = catId[index].order <= 3 ? catId[index].order : 3
            updateOffers.push({id: offer.id, order})
          }
        }
        
        this.updateOrderOffers(updateOffers).then(() => {
          this.reordered = false;
          console.log('Nuevo orden guardado con éxito');
        })
        .catch((err) => {
          console.error('Error al guardar el nuevo orden:', err);
        })
      }
    },
  computed: {
        prevBtn: function(){
            return '<div class="prev-btn"></div>'
        },
        nextBtn: function(){
            return '<div class="next-btn"></div>'
        },
        pages: function(){
            return Math.ceil(this.offers.length / 10)
        },
        pageData: function () {
          return [...this.offers].sort(function (t, e) {
              return t.order - e.order;
          });
      },
        offers: function() {
            var offers = this.getOffers
            return offers
        },
        display: function() {
            if(window.innerWidth < 768){
                return false
            }
            return true
        },
        ...mapGetters({
            'getOffers': 'offers/allOffers',
            'getOffer': 'offers/getOffer',
            'getCategory': 'offers/getSelectedCategory',
            'getStore': 'stores/getSelectedStore',
            'getFilter': 'stores/getFilter'
        })
    }
}
</script>
<style lang="sass">
.manager
  grid-column-start: 2
  grid-column-end: 6
  // display: grid
  display: flex
  align-items: center
  flex-direction: column
  // margin-bottom: 64px
  position: relative
  .back
    width: 100px
    align-items: center
    i
      width: 24px
      height: 24px
  .header
    margin: $xs 0 $xs 0  
    display: flex 
    align-items: center
    justify-content: center
    height: 32px
    width: 100%
    .controls
      width: 100%
      display: flex
      align-items: center
      justify-content: space-between
    .buttons
      display: flex
      flex-grow: 1
      justify-content: flex-end
      a
          margin-left: 8px
  .content-list
    width: 100%
    margin-top: $sm

.pagination
    list-syle: none
    margin-top: 48px
    a
      width: 42px
      height: 42px
      display: block
    li
        display: inline-block
        margin-right: 8px
        vertical-align: top
        height: 42px
        width: 42px
        border: solid 1px $primary
        color: $primary
        line-height: 42px
        text-align: center
        font-family: Montserrat
        font-size: 16px
        font-weight: bold
        letter-spacing: 0.45px
        position: relative
        &:last-of-type
            margin-right: 0
        &.active
            background-color: $primary
            color: #ffffff
.prev-btn
    position: absolute
    left: 50%
    top: 30%
    transform: translate(-50%, -50%)
    width: 12px
    height: 12px
    border-left: 1px solid $primary
    border-bottom: 1px solid $primary
    transform: rotate(45deg)
.next-btn
    position: absolute
    left: 50%
    top: 30%
    width: 12px
    height: 12px
    border-right: 1px solid $primary
    border-bottom: 1px solid $primary
    transform: rotate(-45deg) translate(-50%, -50%)

</style>